/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[iF]ragment" }]*/

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  SiteVariablesFragment,
  ListingsSoldPageFragment,
  PropertyFragment,
} from "src/components/QueryFragments"

import "src/assets/scss/material-kit-react.scss"

import ListingsView from "../views/ListingsView"

const ListingsActivePage = ({ location }) => {
  const {
    contentfulWebsiteGlobalVariables,
    contentfulPageSoldListings,
    allContentfulProperty,
  } = useStaticQuery(
    graphql`
      query {
        contentfulWebsiteGlobalVariables {
          ...SiteVariablesFragment
        }
        contentfulPageSoldListings {
          ...ListingsSoldPageFragment
        }
        allContentfulProperty(
          filter: { text_status: { eq: "Sold" } }
          sort: { fields: date_closing, order: DESC }
        ) {
          nodes {
            ...PropertyFragment
          }
        }
      }
    `
  )

  return (
    <ListingsView
      siteVariables={contentfulWebsiteGlobalVariables}
      pageContent={contentfulPageSoldListings}
      properties={allContentfulProperty.nodes}
      listingType="sold"
      location={location}
    />
  )
}

export default ListingsActivePage
